export class CookieUtils {
  static get(name: string, req?: any) {
    const cookies: { [k: string]: any } = {};
    if (!req && isServer()) {
      return '';
    }
    if (typeof document === 'undefined') {
      return this.getFromRequest(name, req);
    }
    document.cookie.split(';').forEach((el: string) => {
      const [k, v] = el.split('=');
      cookies[k.trim()] = v;
    });
    return cookies[name];
  }

  static getFromRequest(name: string, req: any) {
    if (!req.headers?.cookie) {
      return null;
    }
    // added support for getting cookies from request for ssr usecase
    const cookies: { [k: string]: any } = {};
    req.headers.cookie.split(';').forEach((el: string) => {
      const [k, v] = el.split('=');
      cookies[k.trim()] = v;
    });
    return cookies[name];
  }

  static set(expiresInSeconds: number, name: string, value: any) {
    let d = new Date();
    d = new Date(d.getTime() + 1000 * expiresInSeconds);
    const str = `${name} = ${value}; expires=' + ${d.toUTCString()}; path=/;`;
    document.cookie = str;
  }
}

function getEventTrackingURL(isProd: boolean): string {
  if (isProd) {
    return 'https://analytics.quizizz.com/events';
  }

  return 'https://dev-analytics.quizizz.com/events';
}

function getSessionTrackingURL(isProd: boolean): string {
  if (isProd) {
    return 'https://analytics.quizizz.com/tracking/active-time/events';
  }

  return 'https://dev-analytics.quizizz.com/tracking/active-time/events';
}

export function getTrackingURL(isProd: boolean, type: string = 'event'): string {
  if (type === 'session') {
    return getSessionTrackingURL(isProd);
  }
  return getEventTrackingURL(isProd);
}

export function isServer(): boolean {
  return typeof window === 'undefined';
};

export function getEventTrackingUrlV2(isProd: boolean) {
  if (isProd) {
    return 'https://fnl.quizizz.com/_anserverv2/main/api/v1';
  }
  return 'https://dev-services-2.quizizz.com/_anserverv2/main/api/v1';
}
